import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import Events from 'constants/Events';
import MobileAppInteractor from 'utils/MobileAppInteractor';

import { CurrencyUtils } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';
import ArrayUtils from 'PMT/utils/ArrayUtils';

import { OrderAction } from 'actions';

import { OrdersListStore, SessionStore } from 'stores';
import RestaurantStore from 'stores/RestaurantStore';

// -- entities
import { Order, OrderMenu, OrderProduct } from 'PMT/entities/order';

// -- views
import OrderDetailInfoView from './OrderDetailInfoView';
import OrderProductView from './OrderProductView';
import OrderMenuView from './OrderMenuView';

class OrderDetailView extends Component {
  static propTypes = {
    order: PropTypes.objectOf(Order).isRequired,

    onHide: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,
  };

  componentDidMount() {
    OrdersListStore.addListeners(this.ordersListListeners);
  }

  componentWillUnmount() {
    OrdersListStore.removeListeners(this.ordersListListeners);
  }

  get ordersListListeners(): Array<Listener> {
    return [
      new Listener(Events.UPDATE_ORDER_SUCCESS, this.onOrderUpdate),
      new Listener(Events.UPDATE_ORDER_FAILURE, this.onError),
    ];
  }

  get order(): Order {
    return this.props.order;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }


  //
  // Api events
  //

  onOrderUpdate = () => {
    // TODO: hide only if we have changed the status.
    this.props.onHide();
  };

  onError = () => {
    // TODO
  };

  onSaveOrder = (order: Order) => {
    OrderAction.updateOrder(order);
  };

  onPrintOrder = () => {
    const restaurant = RestaurantStore.getRestaurant();
    MobileAppInteractor.printOrder(this.order, restaurant);
  };

  //
  // Renderers
  //

  renderInfo() {
    return (
      <OrderDetailInfoView
        order={this.order}
        onSave={this.onSaveOrder}
        onPrintOrder={this.onPrintOrder}
        currencyCode={this.currencyCode}

      />
    );
  }

  renderMenus() {
    const menusWithQuantities = this.order.getMenusWithQuantities();

    // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
    // can appears

    return (
      <div className="top-buffer-50">
        {menusWithQuantities.map((menuWithQuantity, index: number) => {
          const orderMenu: OrderMenu = menuWithQuantity.orderMenu;
          const quantity: number = menuWithQuantity.quantity;

          return (
            <OrderMenuView
              key={`${orderMenu.orderId}_${index}`}
              orderMenu={orderMenu}
              quantity={quantity}
              currencyCode={this.currencyCode}
            />
          );
        })}
      </div>
    );
  }

  renderProducts() {
    const productsWithQuantities = this.order.getProductsWithQuantities();

    // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
    // can appears

    return (
      <div>
        {productsWithQuantities.map((productWithQuantity, index: number) => {
          const orderProduct: OrderProduct = productWithQuantity.orderProduct;
          const quantity: number = productWithQuantity.quantity;

          return (
            <OrderProductView
              key={`${orderProduct.orderId}_${index}`}
              orderProduct={orderProduct}
              onMenu={false}
              quantity={quantity}
              currencyCode={this.currencyCode}
            />
          );
        })}
      </div>
    );
  }

  renderFees() {
    return (
      <div className="order_detail__fees text-right">
        {(this.order.fees || []).map(fee => {
          const name = ArrayUtils.find(
            fee.name,
            locale =>
              locale.locale &&
              _.startsWith(
                locale.locale.toLowerCase(),
                I18n.getCurrentLanguageWithoutRegionCode()
              )
          );
          return (
            <div>
              {`${
                (name || fee.name[0]).text
              } : ${CurrencyUtils.formatPriceWithCurrency(
                fee.amountIncludingTax,
                  this.currencyCode
              )}`}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="order_detail">
        {this.renderInfo()}

        {this.renderMenus()}

        {this.renderProducts()}

        <div className="order_detail__prices">
          {this.renderFees()}

          {this.order.isPayed() && !this.order.isFailed() ? (
            <div className="text-right">
              {I18n.tr('components.order.detail.order_total')}{' '}
              {CurrencyUtils.formatPriceWithCurrency(
                this.order.check.total,
                  this.currencyCode
              )}
            </div>
          ) : (
            <div className="text-right">
              {I18n.tr('components.order.detail.order_total')}{' '}
              {CurrencyUtils.formatPriceWithCurrency(
                this.order.getTotalPrice(),
                  this.currencyCode
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default OrderDetailView;



// WEBPACK FOOTER //
// ./scripts/components/order/orderDetailModal/OrderDetailView.js